import { render, staticRenderFns } from "./AiAdviceSearch.vue?vue&type=template&id=87e79a70&scoped=true&"
import script from "./AiAdviceSearch.vue?vue&type=script&lang=ts&"
export * from "./AiAdviceSearch.vue?vue&type=script&lang=ts&"
import style0 from "./AiAdviceSearch.vue?vue&type=style&index=0&id=87e79a70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e79a70",
  null
  
)

export default component.exports